export enum Actions {
  Refresh = 'refresh'
}
